import React from 'react';

import ImageProxy from '@next-image-proxy';

import { Modal, ModalCloseButton, ModalContent, ModalHeading, ModalProps } from '@uikit/index';

export const DepositSuccessfulModal = (props: Omit<ModalProps, 'children'>) => {
  return (
    <Modal {...props}>
      <ModalContent className="flex flex-col items-center p-6 sm:px-12  w-full max-w-[472px]">
        <ModalCloseButton className="!mb-4" />
        <ImageProxy
          src={'launchpad/checkbox-1.png'}
          alt="deposit-success"
          width={84 * 3}
          height={128 * 3}
          quality={100}
          className="mb-4 w-20"
        />
        <ModalHeading className="mb-4">Deposit Successful</ModalHeading>
        <button
          className="button ui-button-solid-green button-lg w-full"
          onClick={() => {
            props.onOpenChange?.(false);
          }}
        >
          Ok
        </button>{' '}
      </ModalContent>
    </Modal>
  );
};

export default DepositSuccessfulModal;
